const IZ_DOMAIN_URLS = [
  'https://amex-dev.iseatz.com',
  'https://amex-qa.iseatz.com',
  'https://amex-stg.iseatz.com',
  'https://www.amextravel.com',
  'https://amex-dark.iseatz.com',
];

const SWITCHFLY_PROD_DOMAIN_URLS = [
  'https://travel.americanexpress.co.uk',
  'https://travel.americanexpress.com.au',
  'https://travel.americanexpress.co.nz',
  'https://travel.americanexpress.co.in',
  'https://reise-services.americanexpress.de',
  'https://viaggi.americanexpress.it',
  'https://viajes.americanexpress.com.mx',
  'https://viajes.americanexpress.es',
  'https://voyages.americanexpress.fr',
  'https://travel.americanexpress.ca',
  'https://voyages.americanexpress.ca',
  'https://travel.americanexpress.com.hk',
  'https://travel.americanexpress.com.sg',
  'https://resebyra.americanexpress.se',
  'https://travel.americanexpress.nl',
  'https://travel.americanexpress.co.jp',
];

const ARRIVA_DOMAIN_URLS = [
  'https://uat-www.americanexpresscruise.com',
  'https://www.americanexpresscruise.com',
];

const LOB_REDIRECTS = [
  'flights',
];

const isValidDestination = (destPage) => {
  const cleanedDestPage = destPage.split('?redirect=');

  const isLobRedirect = LOB_REDIRECTS
    .some((lob) => cleanedDestPage[0].indexOf(lob) === 0);
  if (isLobRedirect) return true;

  if (cleanedDestPage[0].indexOf('https') !== 0) return false;

  const isIseatzPage = IZ_DOMAIN_URLS
    .some((url) => cleanedDestPage[0].includes(url));
  if (isIseatzPage) return true;

  const isArrivaPage = ARRIVA_DOMAIN_URLS
    .some((url) => cleanedDestPage[0].includes(url));
  if (isArrivaPage) return true;

  const isSwitchflyPage = SWITCHFLY_PROD_DOMAIN_URLS
    .some((url) => cleanedDestPage[0].includes(url));
  if (isSwitchflyPage) return true;

  return false;
};

export const validatedSessionDestPath = (nextState, replace) => {
  if (!isValidDestination(nextState.location.query.DestPage)) {
    replace(`https://www.americanexpress.com/${nextState.params.locale}/travel/error`);
  }
};
